import styled from 'styled-components'
import { SPACING } from 'utils'

export const FiltrosContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: ${SPACING.spacing20};
`
